<mat-card>
  <h1 class="col-md-12">{{texteService.getTexte('TITLE_SELECT_TYPE')}}</h1>
  <p class="types-p col-md-12">
    <fa-icon [icon]="faCalendarAlt" class="fa-2x primary-color col-md-1"></fa-icon>
    <span [innerHTML]="this.texteService.getTexte('LABEL_SELECT_TYPE_TEXT_1')"></span>
    <br />
    <fa-icon [icon]="faHeadset" class="fa-2x primary-color col-md-1"></fa-icon>
    <span [innerHTML]="this.texteService.getTexte('LABEL_SELECT_TYPE_TEXT_2')"></span>
  </p>


  <div class="col-md-12 types-label" role="heading" aria-level="2">{{texteService.getTexte('LABEL_SELECT_TYPE_SITUATION')}}</div>
  <div class="d-flex flex-row flex-wrap">
    <button *ngFor="let sit of situations" mat-raised-button (click)="onTypeSituationSelected(sit.code)"
      class="types-button" [color]="situation?.code === sit.code ? 'primary' : 'secondary'">
      {{texteService.getTexte(sit.codeTexte, sit.libelle)}}</button>
  </div>

  <!-- Patient français -->
  <!-- <div *ngIf="displayDemande" class="types-groupe">
    <label class="col-12 types-label">{{texteService.getTexte('LABEL_SELECT_TYPE_ETRE')}}</label>
    <div class="d-flex flex-row flex-wrap">
      <button class="types-button" mat-raised-button (click)="onTypeDemandeSelected('NOU')"
        [color]="demande?.code === 'NOU' ? 'primary' : 'secondary'">{{texteService.getTexte('BTN_DEMANDE_NOU')}}</button>
      <button class="types-button" mat-raised-button (click)="onTypeDemandeSelected(null)"
        [color]="demande == null && demandeChange ? 'primary' : 'secondary'">{{texteService.getTexte('BTN_DEMANDE_AUTRE')}}</button>
    </div>
    <p class="col-12 types-label " *ngIf="demande?.code === 'NOU'">
      {{texteService.getTexte('LABEL_SELECT_TYPE_PREMIER_RDV')}}
    </p>
    <p class="col-12 types-label " *ngIf="demande == null && demandeChange">
      {{texteService.getTexte('LABEL_SELECT_TYPE_DEJA_SUIVI')}}
    </p>
  </div> -->

  <!-- Patient couverture -->
  <div *ngIf="displaySecondAvisFrancaise" class="types-groupe">
    <div class="col-12 types-label" role="heading" aria-level="2">{{texteService.getTexte('LABEL_SELECT_TYPE_SOUHAIT')}}</div>
    <div class="d-flex flex-row flex-wrap">

      <button class="types-button" mat-raised-button (click)="onSecondAvisFrancaiseSelected(false)"
        [color]="secondAvis === false ? 'primary' : 'secondary'">{{texteService.getTexte('BTN_SITUATION_INT_PREMIER')}}</button>

      <button class="types-button" mat-raised-button (click)="onSecondAvisFrancaiseSelected(true)"
        [color]="secondAvis === true ? 'primary' : 'secondary'">{{texteService.getTexte('BTN_SITUATION_INT_SECONDE')}}</button>

    </div>
  </div>

  <app-second-opinion-fr *ngIf="showSecondOpinionFr"></app-second-opinion-fr>

  <!-- Patient internationnal -->
  <div *ngIf="displaySecondAvis" class="types-groupe">
    <div class="col-12 types-label" role="heading" aria-level="2">{{texteService.getTexte('LABEL_SELECT_TYPE_SOUHAIT')}}</div>
    <div class="d-flex flex-row flex-wrap">

      <button class="types-button" mat-raised-button (click)="onSecondAvisSelected(false)"
        [color]="secondAvis === false ? 'primary' : 'secondary'">{{texteService.getTexte('BTN_SITUATION_INT_PREMIER')}}</button>

      <button class="types-button" mat-raised-button (click)="onSecondAvisSelected(true)"
        [color]="secondAvis === true ? 'primary' : 'secondary'">{{texteService.getTexte('BTN_SITUATION_INT_SECONDE')}}</button>

    </div>
  </div>

  <app-second-opinion-international *ngIf="showSecondOpinionInternational"></app-second-opinion-international>

  <!-- Patient internationnal -->
  <div *ngIf="displayCouverture" class="types-groupe">
    <div class="col-12 types-label" role="heading" aria-level="2">{{texteService.getTexte('LABEL_SELECT_TYPE_ETRE')}}</div>
    <div class="d-flex flex-row flex-wrap">
      <button *ngFor="let couv of couvertures" class="types-button" mat-raised-button
        (click)="onTypeCouvertureSelected(couv.code)"
        [color]="couverture?.code === couv.code ? 'primary' : 'secondary'">{{texteService.getTexte(couv.codeTexte, couv.libelle)}}</button>
    </div>

    <p class="col-12 types-label" *ngIf="couverture?.code !== null">
      {{texteService.getTexte('LABEL_SELECT_TYPE_AVERT')}}
    </p>
    <p class="col-12 types-label" *ngIf="couverture?.code === 'CUE'">
        <li>{{texteService.getTexte('LABEL_SELECT_TYPE_AVERT_CUE')}}</li>
    </p>
    <p class="col-12 types-label" *ngIf="couverture?.code === 'NCO'">
        <li>{{texteService.getTexte('LABEL_SELECT_TYPE_AVERT_NCO')}}</li>
    </p>
    <p class="col-12 types-label" *ngIf="couverture?.code === 'CAP'">
        <li>{{texteService.getTexte('LABEL_SELECT_TYPE_AVERT_CAP1')}}</li>
        <li>{{texteService.getTexte('LABEL_SELECT_TYPE_AVERT_CAP2')}}</li>
    </p>
  </div>
</mat-card>
